import request from "@/router/axios";
import website from "@/config/website";

export const loginByUsername = (tenantId, account, password, type, key, code) =>
  request({
    url: "/api/infox-auth/token",
    method: "post",
    headers: {
      "Captcha-Key": key,
      "Captcha-Code": code,
    },
    params: {
      grantType: website.captchaMode ? "captcha" : "password",
      tenantId,
      account,
      password,
      type,
    },
  });
export const loginSmsSend = (phoneNumber) =>
  request({
    url: "api/infox-auth/sms",
    method: "get",
    params: {
      phoneNumber: phoneNumber,
    },
  });

export const loginByPhoneCode = (phoneNumber, code) =>
  request({
    url: "/api/infox-auth/token",
    method: "post",
    params: {
      grantType: "sms",
      phoneNumber: phoneNumber,
      smsVaildCode: code,
    },
  });
export const loginBySocial = (tenantId, source, code, state) =>
  request({
    url: "/api/infox-auth/token",
    method: "post",
    headers: {
      "Tenant-Id": tenantId,
    },
    params: {
      tenantId,
      source,
      code,
      state,
      grantType: "social",
      scope: "all",
    },
  });

export const getButtons = () =>
  request({
    url: "/api/infox-system/menu/buttons",
    method: "get",
  });

export const getUserInfo = () =>
  request({
    url: "/user/getUserInfo",
    method: "get",
  });

export const refreshToken = () =>
  request({
    url: "/user/refesh",
    method: "post",
  });

export const registerGuest = (form, oauthId) =>
  request({
    url: "/api/infox-system/register-guest",
    method: "post",
    params: {
      tenantId: form.tenantId,
      name: form.name,
      account: form.account,
      password: form.password,
      oauthId,
    },
  });

export const getMenu = () =>
  request({
    url: "/api/infox-system/menu/routes",
    method: "get",
    params: {
      application: 1,
    },
  });

export const getCaptcha = () =>
  request({
    url: "/api/infox-auth/captcha",
    method: "get",
  });

export const getTopMenu = () =>
  request({
    url: "/user/getTopMenu",
    method: "get",
  });

export const sendLogs = (list) =>
  request({
    url: "/user/logout",
    method: "post",
    data: list,
  });

export const logout = () =>
  request({
    url: "/user/logout",
    method: "get",
  });
